export default __webpack_public_path__ + "static/logos-139de4847d90b4d2a812e506ce7f7c69.png";